const moreSvg = `<svg aria-hidden='true' viewBox='0,0,1792,1792'><title>More</title><path d='M979 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23zm384 0q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z'></path></svg>`;

export default function diningPopup(model) {
	return `<div class='content-wrapper dining-popup clearfix' style='color:white;' data-key='${model.key}'>
	<div class='popup-row'>
		${model.data.thumbnail ? `
			<div class='popup-col mo-img'>
				<img
					class='dining-image, thumbnail'
					align='left'
					src='${model.data.thumbnail}'
					width='${model.data.thumbnailWidth}'
					height='${model.data.thumbnailHeight}'
				/>
			</div>
		` : ''}
		<div class='popup-col' id='popup-name'>
			<h3 class='dining-title'>${model.data.name}</h3>
			<p class='dining-located-in'>${model.data.map_object.name}</p>
		</div>
	</div>
	<div class='uw-popup-text' id='popup-context'>
		<div>
			<p>
				${model.data.description}
			</p>
		</div>
	</div>
	<p class='align-right'>
		<button
			type='button'
			class='more_button'
			data-dialog-url='${model.htmlView}'
			data-dialog-dining='${model.id}'
			aria-describedby='popup-name popup-context'
		>
			More
			${moreSvg}
		</button>
	</p>
</div>`;
}
